module.exports = __webpack_public_path__ + "assets/GooglePlayBadgeWhite_RU.746f45d9be0cdaabb78fa67030e5334e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/buttons/GooglePlayBadgeWhite_RU.svg
// module id = 183
// module chunks = 0